import "./WordListWord.css";

const WordListWord = (props) => {
  const { word, onClick, editor} = props;
  return (
    <div onClick={() => onClick(word)} className={`${editor ? 'editor-' : ''}word-list-word-container`}>
      {word}
    </div>
  );
};

export default WordListWord;
